import graphql from "babel-plugin-relay/macro";
import { isAfter } from "date-fns";
import { useFragment } from "react-relay";

import { convertDateStringToObj } from "@whoosh/utilities/src/dates";

import { useIsPackageOrderDue_order$key } from "./__generated__/useIsPackageOrderDue_order.graphql";

export const useIsPackageOrderDue = (
  orderRef?: useIsPackageOrderDue_order$key | null
) => {
  const order = useFragment(useIsPackageOrderDueFragmentString, orderRef);
  const dueDate = order?.packageDueDate;

  if (!dueDate) {
    return true;
  }

  const today = new Date();
  return isAfter(today, convertDateStringToObj(dueDate));
};

const useIsPackageOrderDueFragmentString = graphql`
  fragment useIsPackageOrderDue_order on Order {
    packageDueDate
  }
`;
